module.exports = __webpack_public_path__ + "static/media/abdullah.2e83fbf6.png";